import React from "react";
import {Picker} from "../../Utils/Picker";


export default function NominalCodePicker({name, label, value, onChange, options, blank, disabled, className, inlineEdit, onSave, editable, setEditable, small=true}){

    return (
        <Picker
            name={name}
            label={label}
            value={value}
            options={options}
            onSave={onSave}
            onChange={onChange}
            blank={blank}
            disabled={disabled}
            className={small ? className+" small-column" : className}
            inlineEdit={inlineEdit}
            editable={editable}
            setEditable={setEditable}
            optionField={"code"}
            secondOptionTitle={"name"}
        />
    )

}